<template>
 <div class="page" id="mixed-notes">
        <loading :active.sync="isLoading" 
            :can-cancel=false 
            :is-full-page=true
            background-color="#EBF9FF"
            color="#02B99E">
        </loading>
        <div class="decorative-texture top">
            <img :src="require(`@/assets/img/texture.png`)" />
        </div>
        <div class="decorative-texture position-bottom movil-only">
            <img :src="require(`@/assets/img/texture.png`)" />
        </div>
        <vue-snotify></vue-snotify>
        <mnavbar></mnavbar>
         <div class="toolBar">
            <div class="row">
                <!--<div class="col-lg-5 col-xl-5 col-md-5 col-sm-4 col-xs-12">-->
                <div class="col">
                    <div class="user-avatar"  >
                        <div :class="['img-avatar',{'noBorderRadius':item.imagen==undefined}]" :style="{'background-image': 'url('+item.imagen+'),url('+defaultImage+')'}" ></div>
                        <div class="data-avatar">
                            <p class="user-name touchpad noticieroName">{{item.nombre}}</p>
                            <p class="user">Carpeta</p>
                        </div>
                    </div>
                </div>
                <div class="toolActions col-auto">
                <!--<div class="toolActions col-xs-12 col-sm-8 col-lg-5 col-xl-4 col-md-7 offset-lg-2 offset-xl-3 offset-md-0 offset-sm-0">-->
                    <div class="mi-select">
                        <v-select 
                            :value="options2[view2-1]" 
                            :reduce="option => option.value" 
                            :searchable="false"
                            :filterable="false"
                            :clearable="false" 
                            class="style-chooser" 
                            :options="options2" 
                            @input="setSelected2">
                        </v-select>
                    </div>
                    <div class="mi-select" v-if="view2==1">
                        <v-select 
                            :value="options[view-1]" 
                            :reduce="option => option.value" 
                            :searchable="false"
                            :filterable="false"
                            :clearable="false" 
                            class="style-chooser" 
                            :options="options" 
                            @input="setSelected">
                        </v-select>
                    </div>
                </div>
            </div>
        </div>
        ¿
        <section  class="noPadding">
            <div class="containerFull noPadding pNotas"  v-if="view2==2">
                <slider-list from="public" :items="subcarpetas" :cardClass="cardClass" @goTo="goTo"></slider-list>              
                <empty-page title="No hay Búsquedas" message="Agregue elementos" v-if="carpetasReady && subcarpetas.length==0"></empty-page>
            </div>
            <div v-else>
                <panel-notas
                    v-if="view==1"
                    :items="items"
                    :LastEvaluatedKey="LastEvaluatedKey2"
                    @goToNote="goToNote"
                    @loadMore="loadMore"
                    from="public"
                ></panel-notas>
                <panel-text
                    v-if="view==2"
                    :items="items"
                    :LastEvaluatedKey="LastEvaluatedKey2"
                    @goToNote="goToNote"
                    @loadMore="loadMore"
                     from="public"
                ></panel-text>
                <timeline 
                    v-if="view==3"
                    from="public"
                    :items="items" 
                    :LastEvaluatedKey="LastEvaluatedKey2" 
                    @goToNoteTimeline="goToNote"
                    @loadMore="loadMore"
                ></timeline>


                <empty-page title="No hay Notas" message="" v-if="notasReady && items.length==0 "></empty-page>
            </div>
        </section>
</div>
</template>


<script>

import moment from 'moment-timezone'

import mnavbar from '@/components/public/mnavbar'

import emptyPage from '@/components/emptyPage'

import panelNotas from "@/components/panelNotas";
import panelText from "@/components/panelText";
import sliderList from '@/components/sliderList'

import timeline from '@/components/timeline'

import { library } from "@fortawesome/fontawesome-svg-core";
import { faPaperPlane, faEdit, faTrashAlt, faSearch, faTh } from "@fortawesome/free-solid-svg-icons";
library.add(faPaperPlane);
library.add(faEdit);
library.add(faTrashAlt);
library.add(faSearch);
library.add(faTh);

import emailAlert from '@/components/emailAlert'

export default {
    components: {mnavbar,emptyPage,panelText,panelNotas,sliderList,timeline},
    props:['params'],
    data() {
        return {
            view:3,
            view2:1,
            options:[{label:'Modo Gráfico',value:1},{label:'Modo Texto',value:2},{label:'Escaleta',value:3}],
            options2:[{label:'Notas',value:1},{label:'Búsquedas',value:2}],
            isLoading:false,
            menuOn:false,
            url:this.$store.getters.getMainUrl,
            token:this.$store.state.userInfo.token,
            subcarpetas:[],
            items:[],
            item:{},
            itemReady:false,
            LastEvaluatedKey:null,
            LastEvaluatedKey2:null, //notas sueltas
            totalItems:0,
            totalSubcarpetas:0 ,
            busquedas:false,
            searchText:"Ver Búsquedas",
            searchIcon:'search',
            itemsReady:false,
            carpetasReady:false,
            notasReady:false,
            cardClass:'cardEspecial',
            defaultImage:this.$store.state.defaultFolder
        }
    },
    mounted(){
        this.loadItem();
    },
    methods:{
        // ----- CARGA  INFO DE CARPETA  --------
        loadItem(){
            this.isLoading = true;
            var post_data = {
                params: this.params
            };
           
            var self = this;
            axios.post(this.url+'getPublicFolder', JSON.stringify(post_data)) //petición
            .then((response)=>{
                self.isLoading = false;
                if(response.data.success){
                    self.item = response.data.data;
                    self.itemReady = true;
                    self.loadSliders();
                    self.loadItems();
                }else{
                    self.error(response.data.error);
                }
            })
            .catch(function (error) {
                self.isLoading = false;
                self.error(error);
            });
        },
        // ----- CARGA  "QUERYS" GUARDADOS DE BUSQUEDA AVANZADA  --------
        loadSliders(){
            this.isLoading = true;
            var post_data = {
               folderKey: this.item.key
            };
            if(this.LastEvaluatedKey!=null) post_data['LastEvaluatedKey'] = this.LastEvaluatedKey;
            var self = this;
            axios.post(this.url+'getQuerysFromFolder', JSON.stringify(post_data)) //petición
            .then((response)=>{
                self.isLoading = false;
                if(self.subcarpetas.length==0){
                    self.subcarpetas = response.data.result;
                    self.totalSubcarpetas = response.data.total;
                }else{
                    self.subcarpetas = [].concat(self.subcarpetas,response.data.result);
                    self.totalSubcarpetas = self.totalSubcarpetas + response.data.total;
                }
                self.carpetasReady = true;
                self.LastEvaluatedKey = (response.data.LastEvaluatedKey)?  response.data.LastEvaluatedKey:null;
                //self.fillSliders({ndx:0,sliders:response.data.result});
            })
            .catch(function (error) {
                self.isLoading = false;
                self.error(error);
            }); 
        },
        // ----- CARGA NOTAS "SUELTAS" DE CARPETA --------
        loadItems(){
            this.isLoading = true;
            var post_data = {
               folderKey: this.item.key,
               limit:10
            };
            if(this.LastEvaluatedKey2!=null) post_data['LastEvaluatedKey'] = this.LastEvaluatedKey2;
            var self = this;
            axios.post(this.url+'getItemsFromFolder', JSON.stringify(post_data)) 
            .then((response)=>{
                self.isLoading = false;
                if(self.items.length==0){
                    self.items = response.data.result;
                    self.totalItems = response.data.total;
                }else{
                    self.items = [].concat(self.items,response.data.result);
                    self.totalItems = self.totalItems + response.data.total;
                }
                self.notasReady = true;
                if(self.items.length==0){//no hay notas
                    self.showSearch();
                }

                self.LastEvaluatedKey2 = (response.data.LastEvaluatedKey)?  response.data.LastEvaluatedKey:null;
            })
            .catch(function (error) {
                self.isLoading = false;
                self.error(error);
            }); 
        },
        loadMore(){
            if(this.LastEvaluatedKey2!=null)
                this.loadItems();
            else{
                this.$snotify.info('Ya no hay más notas en carpeta', 'Info');
            }
        },
        goTo(item){

            var arr = this.item.key.split('_');
            var ipid = arr[0];
            var query = item.query;

            var encrypted = this.$CryptoJS.AES.encrypt(JSON.stringify(query),'secret 1576508387911');
            var self = this;
            
            var p = { from :'public', fromParams:{ type:'folder', data:this.params } };
            this.$store.commit('saveBack2',p);
     
            this.$router.push({name:'publicNotas',params:{query:query,ipid:ipid}});
    
        },
        goToNote(obj){
            var note_params = {
                table:obj.table,
                key:obj.key,
                entrada:obj.entrada,
                subparams:this.params
            };
            
            var encrypted = this.$CryptoJS.AES.encrypt(JSON.stringify(note_params),'secret 1576508387911');

            var p = { from :'public', fromParams:{ type:'folder', data:this.params } };
            
            this.$store.commit('saveBack2',p);
            
            this.$router.push({name:'public',params:{type:'nota', data:encodeURIComponent(encrypted)}});

        },
        showSearch(){
            this.busquedas = !this.busquedas;
            if(this.busquedas){
                this.loadSliders();
                this.searchText = "Ver Notas"
                this.searchIcon = "th"
            }else{
                this.searchText = "Ver Búsquedas"
                this.searchIcon = "search"
            }
        },
        error(msg){
            this.$snotify.error(msg, 'Error');
        },
        success(msg){
            this.$snotify.success(msg, 'Success');
        },
        setSelected(value){
            this.view = value;
        },
        setSelected2(value){
            this.view2 = value;
        },
    }
}
</script>
